<template>
    <div class="article-chuck-contact">
        <p>
            As much as we are complete opposites on so many levels, we both adore this dance, the people in it and want
            only to grow and help grow in what we know as ‘our Happy Place’.
        </p>
        <p>
            We team up for workshops, chief judging and judging, emceeing, event support and marketing, demos and of
            course, social dancing.
        </p>
        <p>For more information please contact me.</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleChuckContact',
};
</script>
